import { traceQuery } from "@common/api"
import { createFileRoute, notFound } from "@tanstack/react-router"
import { z } from "zod"
import SearchInitiatedLayout from "@/routes/_layout/agent/search-initiated/-components/search-initiated-layout"

const searchSchema = z.object({
  from: z.enum(["chats"]).optional().catch(undefined),
})

export const Route = createFileRoute("/_layout/agent/$id")({
  component: SearchInitiatedPage,
  validateSearch: (search) => searchSchema.parse(search),
  loaderDeps: ({ search: { from } }) => ({ from }),

  loader: async ({ context: { queryClient }, params: { id }, deps }) => {
    try {
      const trace = await queryClient.ensureQueryData(traceQuery({ id }))
      const title = trace.title || "Untitled"
      return {
        breadcrumb:
          deps.from === "chats"
            ? [{ label: "Chats", href: "/agent/chats" }, { label: title }]
            : [{ label: "Home", href: "/agent" }, { label: title }],
      }
    } catch {
      throw notFound()
    }
  },
})

function SearchInitiatedPage() {
  return <SearchInitiatedLayout />
}
